import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { showSuccessToast } from '@utils'
import { useLanguage } from '@context'

interface UpdateScheduledMessageData {
  id: string
  message?: string
  recipientAccountId?: string
  groupId?: string
  scheduledDate?: string // ISO date string
}

const updateScheduledMessage = async (data: UpdateScheduledMessageData): Promise<void> => {
  const { id, ...updateData } = data
  await api.put(`/scheduled-message/${id}`, updateData)
}

export const useUpdateScheduledMessage = () => {
  const queryClient = useQueryClient()
  const { t } = useLanguage()

  return useMutation<void, Error, UpdateScheduledMessageData>({
    mutationFn: updateScheduledMessage,
    onSuccess: async () => {
      showSuccessToast(t('toast.success'), t('toast.scheduledMessageUpdated'))
      await queryClient.invalidateQueries({ queryKey: ['scheduled-messages'] })
    },
  })
}

